import Glide from '@glidejs/glide';
import BaseFeature from '../../foundation/base/base';

class Taxonomy extends BaseFeature {
	constructor(element) {
		super(element);
		this.initDomCache();
		this.el = element;
		this.header = this.el;

		this.taxonomyControls = this.el.querySelector('[data-glide-el="controls"]');
		this.taxonomyListItems = this.el.querySelectorAll('[data-js="taxonomyListItem"]');
		this.taxonomyAssets = this.el.querySelectorAll('[data-js="taxonomyAsset"]');
		this.taxonomyTitles = this.el.querySelectorAll('[data-js="taxonomyTitle"]');
		this.taxonomyAbstracts = this.el.querySelectorAll('[data-js="taxonomyAbstract"]');
		this.taxonomyCtas = this.el.querySelectorAll('[data-js="taxonomyCta"]');

		this.taxonomyHero = this.el.querySelector('[data-js="taxonomyHero"]');
		this.taxonomyHeroTitle = this.el.querySelector('[data-js="taxonomyHeroTitle"]');
		this.taxonomyHeroAbstract = this.el.querySelector('[data-js="taxonomyHeroAbstract"]');
		this.taxonomyHeroCta = this.el.querySelector('[data-js="taxonomyHeroCta"]');
		this.heroAsset = this.el.querySelector('[data-js="heroAsset"]');

		this.closeRegions = this.el.querySelector('[data-js="closeRegions"]');
		this.navArrowLeft = this.el.querySelector('[data-js="navArrowLeft"]');
		this.navArrowRight = this.el.querySelector('[data-js="navArrowRight"]');
		this.taxonomyWrapper = this.el.querySelector('.glide--dragging[data-js="taxonomyWrapper"]');
		this.sliderWrapper = this.el.querySelectorAll('[data-js="taxonomyWrapper"]');

		this.isHidden = 'o-taxonomy--hidden';


		this.addEventListener();
	}


	addEventListener() {
		// For further API options please check the Doc at the authors adress: https://glidejs.com/docs/options/
		// Initializinbg the API

		const sliders = this.sliderWrapper;
		for (let i = 0; i < sliders.length; i++) {
			const glide = new Glide(sliders[i], {
				gap: 15,
				dragThreshold: true,
				bound: true,
				type: 'slider',
				perView: 3,
				breakpoints: {
					800: {
						perView: 2,
					},
					640: {
						perView: 1.5
					}
				}
			});

			glide.mount();
		}


		if (this.closeRegions) {
			this.closeRegions.addEventListener('click', () => {
				this.taxonomyHero.classList.remove('is-fold-out');
			});
		}

		if (this.taxonomyControls && this.taxonomyListItems && this.taxonomyListItems.length <= 3) {
			this.taxonomyControls.classList.add(this.isHidden);
		}

		if (this.taxonomyListItems) {
			for (let i = 0; i < this.taxonomyListItems.length; i++) {
				const taxonomyListItem = this.taxonomyListItems[i];

				taxonomyListItem.addEventListener('click', () => {
					// Replace the hero content with thumbnail data
					if (this.taxonomyAssets[i].src) {
						this.heroAsset.src = this.taxonomyAssets[i].src;

						const heroTitle = this.taxonomyTitles[i].innerText;
						if (heroTitle) {
							this.taxonomyHeroTitle.innerText = heroTitle;
							this.taxonomyHeroTitle.classList.remove(this.isHidden);
						} else {
							this.taxonomyHeroTitle.classList.add(this.isHidden);
						}

						const heroAbstract = this.taxonomyAbstracts[i].innerText;
						if (heroAbstract) {
							this.taxonomyHeroAbstract.innerHTML = heroAbstract;
							this.taxonomyHeroAbstract.classList.remove(this.isHidden);
						} else {
							this.taxonomyHeroAbstract.classList.add(this.isHidden);
						}

						const heroCtaHref = this.taxonomyCtas[i].href;
						if (heroCtaHref) {
							this.taxonomyHeroCta.href = heroCtaHref;
							this.taxonomyHeroCta.classList.remove(this.isHidden);
						} else {
							this.taxonomyHeroCta.classList.add(this.isHidden);
						}
					} else {
						this.heroAsset.src = '';
					}
					this.taxonomyHero.classList.add('is-fold-out');
				});
			}
		}

		if (this.navArrowLeft) {
			this.navArrowLeft.addEventListener('click', () => {
				this.taxonomyHero.classList.remove('is-fold-out');
			});
		}

		if (this.navArrowRight) {
			this.navArrowRight.addEventListener('click', () => {
				this.taxonomyHero.classList.remove('is-fold-out');
			});
		}
	}
}

export default Taxonomy;
